/* eslint-disable import/no-cycle */
import React from 'react'

import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const YearMonthForm = props => {
  const { t } = useTranslation()
  const { date, months, onChange, toYear, minDate } = props

  const currentYear = new Date().getFullYear()
  const minYear = new Date(minDate).getFullYear()
  const fromMonth = new Date(minYear || currentYear - 120, 0)
  const toMonth = new Date(toYear || currentYear, 0)

  const years = []
  for (let i = fromMonth.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
    years.push(i)
  }

  const FIELD_NAME = {
    MONTH: 'MONTH',
    YEAR: 'YEAR'
  }

  const handleChange = function handleChange(e, fieldName) {
    switch (fieldName) {
      case FIELD_NAME.YEAR:
        onChange(new Date(e.target.value, date.getMonth()))
        return
      case FIELD_NAME.MONTH:
        onChange(new Date(date.getFullYear(), e.target.value))
        return
    }
  }

  return (
    <div className="DayPicker-Caption">
      <select
        name="month"
        onChange={e => handleChange(e, FIELD_NAME.MONTH)}
        value={date.getMonth()}
        role="listbox"
        aria-label={t('aria-label.select-month')}
      >
        {months.map((month, i) => (
          <option key={month} value={i}>
            {month}
          </option>
        ))}
      </select>
      <select
        name="year"
        onChange={e => handleChange(e, FIELD_NAME.YEAR)}
        value={date.getFullYear()}
        role="listbox"
        aria-label={t('aria-label.select-year')}
      >
        {years.map(year => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
    </div>
  )
}

YearMonthForm.propTypes = {
  date: PropTypes.instanceOf(Date), //current date
  months: PropTypes.array, //array of months (January, Febuary, etc.)
  onChange: PropTypes.func
}

export default YearMonthForm
